function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDarkSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(30.980393%,30.588236%,30.588236%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.998047 1.998047 L 22.001953 22.001953 M 22.001953 1.998047 L 1.998047 22.001953 ",
    transform: "matrix(0.666667,0,0,0.666667,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDarkSmall);
export default __webpack_public_path__ + "static/media/CloseDarkSmall.1625aa342ad4cd53d1b1e0790e22695a.svg";
export { ForwardRef as ReactComponent };